import { render } from "./TarifarioPrestador.vue?vue&type=template&id=799913c8&scoped=true"
import script from "./TarifarioPrestador.vue?vue&type=script&lang=js"
export * from "./TarifarioPrestador.vue?vue&type=script&lang=js"

import "./TarifarioPrestador.vue?vue&type=style&index=0&id=799913c8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799913c8"]])

export default __exports__